import Image from 'next/image'
import Link from 'next/link'

import { BASE_URL } from '@/shared/lib/const/env'
import { TBurgerLevel2 } from '@/shared/types/deprecated-types'

import cl from './style.module.scss'

interface PopupBannersProps {
	items: TBurgerLevel2[]
}

export const PopupBanners = (props: PopupBannersProps) => {
	const { items } = props

	return (
		<div className={cl.banners} style={{ color: 'black', maxWidth: '400px' }}>
			{items.map(item => {
				if (item.SECTION_LINK) {
					return (
						<Link prefetch={false} key={item.PICTURE} href={item.SECTION_LINK} className={cl.link} target={'_blank'}>
							<Image
								src={BASE_URL + item.PICTURE}
								width={248}
								height={400}
								alt={''}
								className={cl.img}
								priority={true}
								quality={100}
							/>
						</Link>
					)
				}
				return (
					<Image
						src={BASE_URL + item.PICTURE}
						width={248}
						height={600}
						alt={''}
						key={item.PICTURE}
						className={cl.img}
						priority={true}
						quality={100}
					/>
				)
			})}
		</div>
	)
}
